import React from "react";
import { Container } from "basis";

import { Accounts } from "./Accounts";
import { Text } from "../../../components";
import { COLOR } from "../../../components/theme";

export const PaymentMethod = ({
  disabled = false,
  accounts,
  onChange,
  label = "Using account:",
  theme = {
    headingColor: COLOR.LATITUDE_BLUE_INDIGO,
    bodyTextColor: COLOR.LATITUDE_BLUE_INDIGO,
    backgroundColor: COLOR.SECONDARY_LIGHT_BLUE_25,
  },

}) => {
  return (
    <>
      <Container>
        <Text
          textStyle="heading5"
          margin="8 0 2"
          color={theme.headingColor}
          fontFamily="LatitudeSans"
        >
          Your account
        </Text>

        <Text margin="0 0 4" color={theme.bodyTextColor}>
          {label}
        </Text>
      </Container>

      {accounts?.length > 0 && (
        <Container margin="0" border>
          <Accounts
            disabled={disabled}
            accounts={accounts}
            onChange={onChange}
            theme={theme}
          />
        </Container>
      )}
    </>
  );
};
